import { getAnalytics, logEvent } from "firebase/analytics"
import { app } from "./firebase"

const analytics = getAnalytics(app)

export function event(name, path) {
  if (process.env.NODE_ENV === "development") {
    return
  }
  console.log(`action->name:${name}->path:${path}`)
  logEvent(analytics, name, { page_path: path })
}
